<template>
    <AppLayout>
        <LoginForm />
    </AppLayout>
</template>
  
<script setup>
import AppLayout from '@/components/layouts/AppLayout.vue';
import LoginForm from '@/components/pages/Auth/LoginForm.vue';
</script>
